import { useFormContext } from 'react-hook-form';

import { ScheduleDateItem } from './schedule-date-item';

export const ScheduleDate = () => {
  const { register, setValue, watch } = useFormContext();

  const DATE = [
    {
      label: '월',
      value: '1'
    },
    {
      label: '화',
      value: '2'
    },
    {
      label: '수',
      value: '3'
    },
    {
      label: '목',
      value: '4'
    },
    {
      label: '금',
      value: '5'
    },
    {
      label: '토',
      value: '6'
    },
    {
      label: '일',
      value: '0'
    }
  ];

  return (
    <>
      {DATE.map(({ label, value }) => {
        return (
          <div className="w-full" key={value}>
            <div className="flex gap-14 items-start justify-start border-b-1 border-solid border-[#24222A] pb-12 mb-12">
              <div>
                <input
                  {...register(value, {
                    onChange: e => {
                      e.target.checked
                        ? setValue(`${value}`, [
                            {
                              startAt: '',
                              endAt: ''
                            }
                          ])
                        : setValue(value, false);
                    }
                  })}
                  type="checkbox"
                  className="peer hidden"
                  id={`tester-${value}`}
                  value={value}
                  checked={watch(value) && watch(value).length}
                />
                <label
                  className="font-bold flex justify-center items-center w-44 h-44 rounded-8 bg-[#1F1E25] text-[#8E899F] peer-checked:text-[#9170F2] border-2 border-solid border-[#24222A] peer-checked:border-[#9170F2]"
                  htmlFor={`tester-${value}`}
                >
                  <p>{label}</p>
                </label>
              </div>
              <ScheduleDateItem day={value} labelDay={label} />
            </div>
          </div>
        );
      })}
    </>
  );
};
